<!--
 * @Author: p_fy
 * @LastEditors: pfy
 * @Date: 2019-08-12 10:20:01
 * @LastEditTime: 2019-09-29 10:21:44
 * @Version: 1.0
 * @Description: 描述:我的收藏页面 货源、运力、需求、供给
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="content-container">
    <div class="demand-head">
      <div class="slider-list">
        <div :class="{ 'selected': state == '1'}" class="item" @click="toggleState('1')">货源信息</div>
        <div :class="{ 'selected': state == '2'}" class="item" @click="toggleState('2')">运力信息</div>
        <div :class="{ 'selected': state == '3'}" class="item" @click="toggleState('3')">仓库需求</div>
        <div :class="{ 'selected': state == '4'}" class="item" @click="toggleState('4')">罐区需求</div>
        <div :class="{ 'selected': state == '5'}" class="item" @click="toggleState('5')">仓库供给</div>
        <div :class="{ 'selected': state == '6'}" class="item" @click="toggleState('6')">罐区供给</div>
      </div>
    </div>
    <div v-loading="viewManager.loading" class="demand-data">
      <div v-if="titleData.length > 1" class="demand-data-header">
        <ul :class="{'transport-header': state == '2', 'goods-header': state == '1'}">
          <li v-for="(title, index) of titleData" :key="index">{{ title }}</li>
        </ul>
      </div>
      <div ref="data-body" class="demand-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item, index) of data">
          <div :key="index" class="data-item">
            <ul :class="{'transport-list': state == '2', 'goods-list': state == '1'}" :style="{'background-color': item.publishStatus == '1' ? 'rgb(245, 245, 245)' : ''}">
              <el-tooltip class="item" effect="dark" :content="`${item.param1}`" placement="top">
                <li>{{ item.param1 }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${item.param2}`" placement="top">
                <li>{{ item.param2 }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${item.param3}`" placement="top">
                <li>{{ item.param3 }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${item.param4}`" placement="top">
                <li>{{ item.param4 }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${item.param5}`" placement="top">
                <li>{{ item.param5 }}</li>
              </el-tooltip>
              <el-tooltip v-if="item.param7" class="item" effect="dark" :content="`${item.param7}`" placement="top">
                <li>{{ item.param7 }}</li>
              </el-tooltip>
              <li>
                <el-button style="color: #be2316 !important;" type="text" @click="favorites(item)">{{ item.param6 }}</el-button>
                <el-divider direction="vertical" />
                <template v-if="authStatus == '2'">
                  <!-- 货源-运力 -->
                  <template v-if="state == '2'">
                    <el-button v-permission="['1-0','1-1','1-2']" type="text" @click="invitationBid(item)">邀请报价</el-button>
                  </template>
                  <template v-if="state == '1'">
                    <el-button v-permission="['2-1','2-2']" type="text" :disabled="item.offerType === 1" @click="quotation(item)">{{ item.offerType === 1?'已报':'报价' }}</el-button>
                  </template>
                  <!-- 货源-运力 -->
                  <template v-if="(state == '3' || state == '4') && item.publishStatus == '2'">
                    <template v-if="item.inviteUserFlag == '0'">
                      <el-button v-permission="['3-1','3-2']" style="color: #66b1ff !important;" type="text" @click="invitation(item)">邀请看仓</el-button>
                    </template>
                    <template v-else>
                      <el-button v-permission="['3-1','3-2']" style="color: #be2316;" type="text">已邀请</el-button>
                    </template>
                  </template>
                  <template v-if="(state == '5' || state == '6') && item.appointmentStatus == '1' && item.publishStatus == '2'">
                    <el-button v-permission="['4-1','4-2']" style="color: #be2316 !important;" type="text">已预约</el-button>
                  </template>
                  <template v-if="(state == '5' || state == '6') && item.appointmentStatus != '1' && item.publishStatus == '2'">
                    <el-button v-permission="['4-1','4-2']" style="color: #66b1ff !important;" type="text" @click="order(item)">预约看仓</el-button>
                  </template>
                  <template v-if="(state == '5' || state == '6') && item.publishStatus == '3'">
                    <el-button v-permission="['4-1','4-2']" style="color: #be2316 !important;" type="text">已成交</el-button>
                  </template>
                  <template v-if="(state == '5' || state == '6') && item.publishStatus == '2'">
                    <el-button v-permission="['4-1','4-2']" style="color: #66b1ff !important;" type="text" @click="deal(item)">成交</el-button>
                  </template>
                  <template v-if="state == '5' || state == '6'">
                    <el-divider direction="vertical" />
                  </template>
                </template>
                <el-button plain size="small" style="color: #be2316 !important;" @click="supplyInfo(item)">
                  详情
                  <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <goodsFullInfo v-if="!item.hidden && state == '1' " style="position: initial;" :goods="item" />
            <transportFullInfo v-if="!item.hidden && state == '2' " :transport="item" />
            <storeDemandInfo v-if="!item.hidden && state == '3' " :demand="item" />
            <tankDemandInfo v-if="!item.hidden && state == '4' " :demand="item" />
            <storeSupplyInfo v-if="!item.hidden && state == '5' " style="position: initial;" :supply="item" />
            <tankSupplyInfo v-if="!item.hidden && state == '6' " style="position: initial;" :supply="item" />
          </div>
        </template>
      </div>
      <div class="demand-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
    <store-deal ref="dealDialog" :deal-type="getDealType" :deal-manager="dealManager.visible" :deal-data="dealManager.data" :demand-data="null" @close="dealManager.close" @closeSuccess="dealManager.close" />
    <invite-warehousing ref="inviteDialog" :warehousing-type="state == '3' ? '1' : '2'" :invitation-manager="invitationManager.visible" :invitation-form="invitationManager.data" @close="invitationManager.close" />
    <order-warehousing ref="orderDialog" :order-manager="orderManager.visible" :order-data="orderManager.data" :order-type="getDealType" @close="orderManager.close" />
    <!-- 邀请报价  -->
    <invitation-offer
      v-if="invitationofferManager.visiable"
      :area="area"
      :data="invitationofferManager.data"
      @close="invitationofferManager.visiable = false"
    />
    <!-- 报价对话框  -->
    <offer ref="offer-dialog" @done="loadData" />
  </div>
</template>

<script>
// 货源详情
import goodsFullInfo from '../../goods/components/goodsFullInfo'
// 运力详情
import transportFullInfo from '../../transport/components/transportFullInfo'
// 普仓需求详情
import storeDemandInfo from '../../store/store-demand-list/components/storeDemandInfo'
// 普仓供应详情
import storeSupplyInfo from '../../store/store-supply-list/components/storeSupplyInfo'
// 罐区需求详情
import tankDemandInfo from '../../store/tank-demand-list/components/tankDemandInfo'
// 罐区供应详情
import tankSupplyInfo from '../../store/tank-supply-list/components/tankSupplyInfo'
// 成交
import storeDeal from '../../store/components/storeDeal'
// 邀请看仓
import inviteWarehousing from '../../../cloud/components/inviteWarehousing'
// 预约看仓
import orderWarehousing from '../../../cloud/components/orderWarehousing'
// 邀请报价
import invitationOffer from '../../../petro-transport/components/invitationOffer'
// 报价
import offer from '@/views/personal/transport/offer'
import { mapGetters } from 'vuex'
import { findCollection, conllection, getArea } from '@/api/personal/user/collection/collection'
import mixinsFunction from '@/utils/mixinsFunction'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()

export default {
  name: 'MyCollection',
  components: {
    goodsFullInfo,
    transportFullInfo,
    storeDemandInfo,
    storeSupplyInfo,
    tankDemandInfo,
    tankSupplyInfo,
    storeDeal,
    inviteWarehousing,
    orderWarehousing,
    invitationOffer,
    offer
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      data: [],
      area: [],
      state: '0',
      viewManager: {
        loading: true
      },
      invitationManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadData()
          this.invitationManager.visible = false
        }
      },
      invitationofferManager: {
        visiable: false,
        data: {}
      },
      orderManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadData()
          this.orderManager.visible = false
        }
      },
      dealManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadData()
          this.dealManager.visible = false
        }
      },
      titleData: [],
      // 表格数据
      pagination: { // 分页参数
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(['roles', 'userInfo', 'authStatus']),
    getPublishState() {
      return this.state ? 2 : 1
    },
    getDealType() {
      if (this.state == '5') {
        return '1'
      } else if (this.state == '6') {
        return '2'
      }
      return '1'
    }
  },
  watch: {
    state: function() {
    }
  },
  created: function() {
    (async() => {
      await this.statefind()
      await this.getArea()
      this.loadData()
    })()
  },
  methods: {
    // 根据权限初始化菜单
    statefind() {
      if (this.roles == '1-1' || this.roles == '1-2') {
        this.state = '2'
      }
      if (this.roles == '2-1' || this.roles == '2-2') {
        this.state = '1'
      }
      if (this.roles == '4-1' || this.roles == '4-2' || this.roles == '3-1' || this.roles == '3-2') {
        this.state = '3'
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 列表切换监听
    toggleState(state) {
      if (this.userInfo.isAdmin == 0) {
        return false
      }
      this.state = state
      this.loadData()
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 初始化查询
    loadData() {
      this.viewManager.loading = true
      this.loadTableData()
    },
    // 分页监听
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 分页监听
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 成交
    deal(item) {
      this.dealManager.data = item
      this.dealManager.visible = true
    },
    // 邀请看仓
    invitation(supply) {
      this.invitationManager.data = supply
      this.invitationManager.visible = true
    },
    // 预约看仓
    order(supply) {
      // appointment({ supplyId: supply.id, contactMan: supply.linkMan, tel: supply.telephone, demandType: this.state == '5' ? '1' : '2' }).then(res => {
      this.orderManager.data = supply
      //   supply.appointmentStatus = '1'
      this.orderManager.visible = true
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.data.map(res => {
          // console.log(337, res)
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 查询列表
    loadTableData() {
      const params = Object.assign({ moduleType: this.state }, this.pagination)
      findCollection(params)
        .then(data => {
          console.log(349, data)
          // this.data = data.result.rows
          this.data = []
          this.setData(data.result.rows.map(res => {
            res.hidden = true
            return res
          }))
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.data = []
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 收藏
    favorites(item) {
      // 发起收藏?取消收藏的请求
      conllection({ id: item.collectionId, moduleId: item.id, moduleType: this.state, collectionStatus: '2' }).then(data => {
        this.$message({
          offset: 100,
          message: '取消收藏成功',
          type: 'warning'
        })
        this.loadData()
      }).catch(error => {
        console.error(error)
      })
    },
    setData(res) {
      switch (this.state) {
        case '1':
          this.titleData = ['起始地/目的地', '货物名称', '运输种类', '承载能力', '期望价格', '发布时间', '操作']
          this.data = res.map(val => {
            val.param1 = `${val.startPlaceLabel} - ${val.stopPlaceLabel}`
            val.param2 = val.goodsName
            val.param3 = val.goodsTypeLabel
            val.param4 = `${val.weight}吨`
            val.param5 = `${val.expectPrice}元`
            val.param7 = val.createDate
            // val.fileUrl = val.fileUrl.split(',').filter(n => n)
            val.param6 = '取消收藏'
            return val
          })
          break

        case '2':
          this.titleData = ['起始地/目的地', '运输方式', '运输种类', '承载能力', '期望价格', '发布时间', '操作']
          this.data = res.map(val => {
            val.param1 = `${val.startPlaceLabel} - ${val.stopPlaceLabel}`
            val.param2 = val.transportTypeLabel
            val.param3 = val.goodsTypeLabel
            val.param4 = `${val.weight}吨`
            val.param5 = `${val.expectPrice}元`
            val.param7 = val.createDate
            val.fileUrl = val.fileUrl.split(',').filter(n => n)
            val.param6 = '取消收藏'
            return val
          })
          break
        case '3':
          this.titleData = ['租单名称', '储存类型', '库房位置', '需求面积', '期望租金', '操作']
          this.data = res.map(val => {
            val.param1 = val.demandName
            val.param2 = val.storageTypeLabel
            val.param3 = val.storageLocationLabel
            val.param4 = `${val.demandArea}m²`
            val.param5 = `${val.expectPrice}m²/天`
            val.param6 = '取消收藏'
            return val
          })
          break
        case '4':
          this.titleData = ['租单名称', '储存类型', '库房位置', '罐区容积', '期望租金', '操作']
          this.data = res.map(val => {
            val.param1 = val.demandName
            val.param2 = val.tankTypeLabel
            val.param3 = val.storageLocationLabel
            val.param4 = `${val.goodsCubage}m³`
            val.param5 = `${val.expectPrice}m³/天`
            val.param6 = '取消收藏'
            return val
          })
          break
        case '5':
          this.titleData = ['租单名称', '储存类型', '库房位置', '可租用面积', '期望租金', '操作']
          this.data = res.map(val => {
            val.param1 = val.supplyName
            val.param2 = val.storageTypeLabel
            val.param3 = val.storageLocationLabel
            val.param4 = `${val.rentableArea}m²`
            val.param5 = `${val.expectPrice}m²/天`
            val.param6 = '取消收藏'
            return val
          })
          break
        case '6':
          this.titleData = ['租单名称', '储存类型', '库房位置', '罐区面积', '期望租金', '操作']
          this.data = res.map(val => {
            val.param1 = val.supplyName
            val.param2 = val.tankTypeLabel
            val.param3 = val.storageLocationLabel
            val.param4 = `${val.potArea}m³`
            val.param5 = `${val.expectPrice}m³/天`
            val.param6 = '取消收藏'
            return val
          })
          break
        default:
      }
    },
    // 邀请报价,item为运力
    invitationBid(item) {
      if (item.sendStatus == '0') {
        this.$message({
          message: '该运力已经下架，不能邀请报价!',
          type: 'error'
        })
        return false
      }
      this.isDetificate().then(() => {
        this.invitationofferManager.data = item
        this.invitationofferManager.visiable = true
      })
    },
    // 报价
    quotation(item) {
      if (item.sendStatus == '0') {
        this.$message({
          message: '该货源已经下架，不能报价!',
          type: 'error'
        })
        return false
      }
      this.$refs['offer-dialog'].open(item)
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;

.content-container {
  .demand-head {
    padding: 0.5rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    margin-bottom: 1rem;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      // border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 16.6%;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        // margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .demand-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .demand-data {
    .demand-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.6%;
          }
          &:nth-child(2) {
            flex-basis: 16.6%;
          }
          &:nth-child(3) {
            flex-basis: 16.6%;
          }
          &:nth-child(4) {
            flex-basis: 16.6%;
          }
          &:nth-child(5) {
            flex-basis: 16.6%;
          }
          &:nth-child(6) {
            flex-basis: 16.6%;
          }
        }
      }
    }

    .demand-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(2) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(3) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(4) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(5) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(6) {
              flex-basis: 16.6%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .demand-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .invitation-data {
    .invitation-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 15%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 15%;
          }
          &:nth-child(10) {
            flex-basis: 15%;
          }
        }
      }
    }
    .invitation-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 15%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 15%;
            }
            &:nth-child(10) {
              flex-basis: 15%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .invitation-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
}

.transport-list, .transport-header, .goods-list, .goods-header {
  li:nth-child(1) {
    flex-basis: 13% !important;
  }
  li:nth-child(2) {
    flex-basis: 13% !important;
  }
  li:nth-child(3) {
    flex-basis: 13% !important;
  }
  li:nth-child(4) {
    flex-basis: 13% !important;
  }
  li:nth-child(5) {
    flex-basis: 13% !important;
  }
  li:nth-child(6) {
    flex-basis: 13% !important;
  }
  li:nth-child(7) {
     flex-basis: 22% !important;
  }
}
</style>
